<div class="shipment-status flex align-center text-nowrap" [ngClass]="'shipment-status--' + classMap[value]">
  <span class="shipment-status__badge small weight-medium px-2 py-1 radius-1">
    {{ statusTranslationKey + "." + value | translate }}
  </span>

  <small *ngIf="shipment?.delayedAction" class="label bg-warn text-white radius-1 small px-1">
    {{ statusTranslationKey + '.Delayed' | translate }}
  </small>
  <small
    class="label text-nowrap"
    *ngIf="shipment?.wccIntegrationStatus"
    [ngClass]="{
      'bg-warn': shipment.wccIntegrationStatus === WccIntegrationStatusType.IntegrationFailed
      || shipment.wccIntegrationStatus === WccIntegrationStatusType.CancelationFAILED
      || shipment.wccIntegrationStatus === WccIntegrationStatusType.IntegrationCanceled,
      'bg-accent': shipment.wccIntegrationStatus === WccIntegrationStatusType.WaitingAssignment
      ||  shipment.wccIntegrationStatus === WccIntegrationStatusType.IntegrationInProgress,
      'bg-success': shipment.wccIntegrationStatus === WccIntegrationStatusType.Integrated
    }"
  >
    {{ ('shared.Enum.WccIntegrationStatusType.' + shipment.wccIntegrationStatus) | translate }}
  </small>
</div>
